<template>
	<div>
		<div id="intro">
			<h2>Voraussetzungen für das Update</h2>
			<div class="wrapper">
			<p>Für das Update auf <riskop15/> benötigen Sie mindestens:</p>
			<ul>
				<li>Java 8-14 (empfohlen <strong>Java 11</strong>)</li>
				<li>Apache Tomcat 7-9 (empfohlen <strong>Version 9</strong>)</li>
				<li>Aktuelles Datenbanksystem:
					<ul>
						<li><strong>PostgreSQL</strong> (ab Version 9, empfohlen <strong>Version 12</strong>) oder</li>
						<li>mysql (ab Version 5.6) oder</li>
						<li>MS-SQL-Server ab Version 2008</li>
					</ul>
				</li>
			</ul>
			<p>Falls Ihre System diese Voraussetzungen nicht erfüllt, führen Sie bitte zunächst die Installation der neuen Komponenten entsprechend der
				<a href="installation">Installationsanleitung</a> durch.
			</p>
			</div>
		</div>

		<h2>Konfiguration</h2>
		<div class="wrapper">
		<div id="selection">
			<p>Wählen Sie bitte hier die Konfiguration aus, auf der das Update stattfinden soll:</p>
			<div class="form-group row">
				<div class="col-sm-12 col-md-6 col-lg-3 col-xl-3 mb-2">
					<p>Aktuell&nbsp;installierte&nbsp;Version:</p>
				</div>
				<div class="col-sm-12 col-md-6 col-lg-3 col-xl-3 mb-2">
					<select class="custom-select" id="currentVersion" name="currentVersion" v-model="currentVersion">
						<option v-for="(v, idx) in currentVersions" :key="idx" :value="v.value">{{ v.name }}</option>
					</select>
				</div>
				<div class="col-sm-12 col-md-6 col-lg-3 col-xl-3 mb-2">
					<select class="custom-select" id="numerus" name="numerus" v-model="numerus">
							<option v-for="(v, idx) in numeri" :key="idx" :value="v.value">{{ v.name }}</option>
					</select>
				</div>
				<div class="col-sm-12 col-md-6 col-lg-3 col-xl-3 mb-2">
					<select class="custom-select" id="kritikomCoinstallation" name="kritikomCoinstallation" v-model="kritikomCoinstallation">
							<option v-for="v in kritikomCoinstallations" :key="'coinstall_' + v.value" :value="v.value">{{ v.name }}</option>
					</select>
				</div>

			
				<div class="col-sm-12 col-md-6 col-lg-3 col-xl-3 mb-2">
					<select class="custom-select" id="osType" name="osType" v-model="osType">
							<option v-for="v in osTypes" :key="'ostype_' + v.value" :value="v.value">{{ v.name }}</option>
					</select>
				</div>
				<div class="col-sm-12 col-md-6 col-lg-3 col-xl-3 mb-2">
					<select class="custom-select" id="javaVersion" name="javaVersion" v-model="javaVersion">
							<option v-for="v in javaVersions" :key="'java_' + v.value" :value="v.value">{{ v.name }}</option>
					</select>
				</div>
				<div class="col-sm-12 col-md-6 col-lg-3 col-xl-3 mb-2">
					<select class="custom-select" id="tomcatVersion" name="tomcatVersion" v-model="tomcatVersion">
							<option v-for="v in tomcatVersions" :key="'tomcat_' + v.value" :value="v.value">{{ v.name }}</option>
					</select>
				</div>
				<div class="col-sm-12 col-md-6 col-lg-3 col-xl-3 mb-2">
					<select class="custom-select" id="dbType" name="dbType" v-model="dbType">
							<option v-for="v in dbTypes" :key="'dbtype_' + v.value" :value="v.value">{{ v.name }}</option>
					</select>
				</div>
			</div>
		</div>

		<div v-if="numerus == 'multi' || kritikomCoinstallation == 'yes'" class="alert alert-warning">
			<ul>
				<li v-if="numerus == 'multi'">
					Bei mehreren riskop-Instanzen in einem Tomcat sollten die riskop-Instanzen mit der gleichen Version
					installiert sein, da sich die Versions-Anforderungen an gemeinsame Resourcen wie Java, Tomcat und
					Datenbanktreiber unterscheiden können.
				</li>
				<li v-if="kritikomCoinstallation == 'yes'">
					<strong>kritikom-1</strong> ist erst ab der Version 1.3.5 kompatibel mit Java 9-14. <strong>Bitte führen Sie
					ggf. auch hier ein Update durch!</strong>
				</li>
			</ul>
		</div>
		</div>

		<h2>Download von riskop</h2>
		<div class="wrapper">
		<p>Die für das Update von <riskop15/> notwendigen Java-Web-Anwendung <code>riskop.war</code> und die Konfigurationsdatei <code>riskop.properties</code> befinden
			sich in einem ZIP-Archiv.</p>
		<p>Dieses Archiv können Sie unter
			<a href="https://www.fumix.de/kunden-login" target="_blank">Kunden-Login</a> herunterladen, nachdem Sie sich dort durch Upload Ihrer aktuellen
			Lizenz authentifiziert haben.
		</p>
		</div>

        <h2>Vorbereitung des Updates</h2>
<div class="wrapper">
		<h3>Sichern der bestehenden Installation</h3>
		<p>Sichern Sie am besten das gesamte <tomcat-path :os="osType" path=""/>-Verzeichnis in ein ZIP-Archiv.</p>

		<h3>Tomcat Dienst stoppen</h3>
		<p>Der Tomcat sollte vor dem Sichern der DB und dem Durchführen des Updates gestoppt werden.</p>

		<h3>Backup der Datenbank</h3>
		<div class="alert alert-warning">
			Im Update-Prozess führt <riskop15/> Schema-Änderungen auf der Datenbank durch. Daher ist ein Datenbank-Backup notwendig,
			um bei Problemen beim Update-Prozess wieder auf die alte Version zurückrollen zu können.
		</div>
		<div v-if="dbType == 'postgres'">
			<p>Für {{dbName}} verwenden Sie</p>
			<p><pg-cmd :os="osType" cmd="pg_dump" args="-U <riskop DB user> -f riskop_backup.sql <riskop DB name>"/></p>
		</div>
		<div v-else>
			<p>Für {{dbName}} folgen Sie bitte den Anleitungen des Datenbankherstellers.</p>
		</div>
</div>
	
	<h2>Anwendung ersetzen</h2>
	<div class="wrapper">
	<p>Kopieren Sie die Datei <code>riskop.war</code> aus dem riskop-ZIP-Archiv in das Tomcat-Verzeichnis <tomcat-path :os="osType" path="webapps"/>
	<div v-if="numerus == 'multi'">
		Bei mehreren <riskop15/>-Instanzen in einem Tomcat werden die Instanzen über den Namen der <code>war</code>-Datei im 
		<tomcat-path :os="osType" path="webapps"/> unterschieden. Ersetzen sie diese Dateien für jede riskop-Instanz, die aktualisiert werden soll,
		durch das neue <code>riskop.war</code>. Achten Sie auf den korrekten Namen der Datei, da aus diesem die URL zum Aufruf der Instanzen
		gebildet wird und die Konfigurationsdateien den Instanzen zugeordnet werden.
	</div>
	</div>

	<h2>Konfiguration anpassen</h2>
	<div v-if="currentVersion == '1.5'" class="alert alert-success">
		Da Sie bereits riskop in der Version 1.5 nutzen, müssen keine Anpassungen an der Konfiguration vorgenommen werden.
	</div>
	<div v-else>
		<div class="wrapper">
		<h4>Datenbank-Verbindungs-Parameter</h4>
		Mit der Version 1.5 sind die Datenbank-Verbindungsparameter aus <tomcat-path :os="osType" path="conf/Catalina/localhost/riskop.xml"/>
		nach <tomcat-path :os="osType" path="conf/riskop.properties"/> gewandert.
		Übernehmen Sie die Werte aus <code>riskop.xml</code> in neue Parameter
			in <code>riskop.properties</code>:
		<pre>db.connection.url=<strong>Attribut <em>url</em> aus riskop.xml</strong>
db.connection.username=<strong>Attribut <em>username</em> aus riskop.xml</strong>
db.connection.password=<strong>Attribut <em>password</em> aus riskop.xml</strong></pre>
		<div v-if="currentVersion == '1.2-3'">
			<h4>Weiterleitung an CIRSmedical</h4>
			Mit der Version 1.4 wurden die Parameter zur Weiterleitung an CIRSmedical geändert.
			<ul>
				<li><strong>Alt:</strong>
					<pre>#RIPA_CIRS_CSV_ADDRESS=&lt;Mailadresse&lt;
#RIPA_CIRS_MEDICAL_ID=&lt;cirs medical id&lt;
#RIPA_CIRS_INTERFACE_ID=&lt;interface_id&lt;</pre>
				</li>
				<li><strong>Neu:</strong>
					<pre># Valid values are NONE, CIRS_MEDICAL, CIRS_NETZ_DE.
EXTERNAL_CIRS=NONE</pre>
				</li>
			</ul>
			<p>Falls der Versand and CIRSmedical genutzt werden soll, tragen Sie <code>EXTERNAL_CIRS=CIRS_MEDICAL</code> ein, ansonsten <code>EXTERNAL_CIRS=NONE</code>.
			Die alten <code>RIPA_CIRS...</code> Zeilen können Sie löschen.</p>
			<div class="alert alert-info">
				In der alten Konfiguration war der Versand deaktiviert, wenn die <code>RIPA</code>-Parameter durch einen <strong>#</strong> auskommentiert waren.
			</div>
			<h4>Sprachkonfiguration</h4>
			Fügen Sie die Zeile <code>application.locale=de</code> ein, um Deutsch als Standard-Sprache für <riskop15/> einzustellen.
		</div>
		<div v-if="numerus == 'multi'">
			<h4>Vorgehen bei mehreren riskop-Instanzen</h4>
			Bei mehreren <riskop15/>-Instanzen in einem Tomcat hat jede Instanz ihre eigene Konfiguration. Die Zuordnung erfolgt über die Dateinamen. Sie müssen daher die 
			Anpassung jeweils für alle Instanzen durchführen.
		</div>
		</div>
	</div>


	<h2>JDBC-Datenbanktreiber aktualisieren</h2>
	<div v-if="currentVersion == '1.5'" class="alert alert-success">
		Da Sie bereits riskop in der Version 1.5 nutzen, sollte der DB-Treiber bereits auf dem aktuellen Stand sein.
	</div>
	<div v-else>
		<div class="wrapper">
		<p>Der Datenbanktreiber ist ein sogenannter <code>JDBC</code>-Treiber und muss im Verzeichnis <tomcat-path :os="osType" path="lib"/> abgelegt werden.</p>
		<div v-if="dbType == 'postgres'">
			<riskop15/> benötigt für {{dbName}} einen aktuellen JDBC-Treiber der 42-er Reihe. 
			Für {{javaName}} ist das <code>postgresql-42.x.x.jar</code>.
			Prüfen sie, ob sich im <tomcat-path :os="osType" path="lib"/> ein passender Treiber befindet. Wenn nicht, löschen Sie ggf. den alten
			<code>postgresql...jar</code> Treiber und installieren den für Sie passenden von 
			<a title="PG JDBC" href="https://jdbc.postgresql.org/download.html" target="_blank">Postgres JDBC Downloads</a>.
			<div class="alert alert-warning">Die Treiber aus der <code>postgresql-9.x...jar</code> Linie funktionieren mit <riskop15/> nicht mehr.</div>
		</div>
		<div v-if="dbType == 'mssql'">
			<p>
				<riskop15/> benötigt für {{dbName}} einen JDBC-Treiber von
				<a title="MS SQL JDBC" href="https://www.microsoft.com/de-de/download/details.aspx?id=11774" target="_blank">MSSQL JDBC</a>.
			</p>
			<p>Beachten Sie bitte, dass für Java 8+ der <code>JDBC 4.2</code> Treiber
				benötigt wird.</p>
		</div>
		<div v-if="dbType == 'mysql'">
			<p>Den JDBC-Treiber zu {{ dbName }} finden Sie auf
			<a title="MySQL JDBC" href="https://dev.mysql.com/downloads/connector/j/" target="_blank">Connector-J Downloads</a>.</p>
			<p>Informationen
				zur Kompatiblität der Treiber-Versionen finden Sie auf <a title="MySQL JDBC" href="https://dev.mysql.com/doc/connector-j/8.0/en/connector-j-versions.html"
				target="_blank">Connector-J Versionen</a>.</p>
		</div>
		<div class="alert alert-warning">Falls sie einen neuen Treiber nach <tomcat-path :os="osType" path="lib"/> installieren, löschen Sie ggf. den alten.</div>
		</div>
	</div>

	<div v-if="currentVersion != 1.5">
		<h2>Entfernen alter Konfigurationsdateien</h2>
		<div class="wrapper">
		<p>Mit der Version 1.5 werden folgende Konfigurationsdateien nicht mehr benötigt:</p>
		<ul>
			<li><tomcat-path :os="osType" path="conf/riskop_hibernate.cfg.xml"/></li>
			<li><tomcat-path :os="osType" path="conf/Catalina/localhost/riskop.xml"/></li>
		</ul>
		<div v-if="numerus == 'multi'">
			Bei mehreren <riskop15/>-Instanzen in einem Tomcat müssen Sie diese Konfigurationsdateien jeweils für die einzelnen Instanzen entfernen.
			Die Zuordnung erfolgt über die Dateinamen. 
		</div>
		<div class="alert alert-warning">
			Insbesondere eine alte <tomcat-path :os="osType" path="conf/Catalina/localhost/riskop.xml"/> kann zu Fehlern beim Start des Tomcat führen.
			Daher muss diese Datei entweder aus dem <tomcat-path :os="osType" path="conf/Catalina/localhost/"/> Verzeichnis verschoben oder gelöscht oder 
			so umbenannt werden, dass der Tomcat sie nicht mehr öffnet (z.B. durch die Dateiendung <code>.bak</code>).
		</div>
		</div>
	</div>

	<h2>Entfernen alter Temporärer Verzeichnisse</h2>
	<div class="wrapper">
	<p>Gelegentlich kommt es nach Updates zu Problemen beim Neustart des Tomcat, wenn noch temporäre Dateien der alten Version vorhanden sind.
	Löschen Sie daher folgende Verzeichnisse:</p>
	<ul>
		<li><tomcat-path :os="osType" path="webapps/riskop"/> (die vom Tomcat ausgepackte Anwendung)</li>
		<li><tomcat-path :os="osType" path="work/Catalina/localhost/riskop"/> (alte Session-Daten)</li>
	</ul>
	<div v-if="numerus == 'multi'">
		Bei mehreren <riskop15/>-Instanzen hat jede Instanz ihre eigenen temporären Verzeichnisse, die Sie am Instanznamen erkennen.
		Löschen Sie diese Verzeichnisse für alle aktualisierten Instanzen.
	</div>
	</div>


	<h2>Tomcat Starten</h2>
	<div class="wrapper">
	Starten Sie jetzt wieder den Tomcat-Dienst.
	</div>

	<h2>Update Abschließen und Testen</h2>
	<div class="wrapper">
	<p>Wenn der Dienst vollständig gestartet ist (das kann das erste Mal bis zu einer Minute dauern) kann das Update
      über folgende URL fertig gestellt werden:</p>
	<p>
		<a href="http://localhost:8080/riskop/admin/Start.do" target="_blank">http://localhost:8080/riskop/admin/Start.do</a>
	</p>
	<p>Autorisieren Sie sich durch hochladen Ihrer Lizenzdatei.</p>
	<p>Die Anwendung erkennt selbstständig, ob für die neue Version Änderungen des Datenbankschemas notwendig sind. Falls ja,
		erscheint ein <strong>Datenbank&nbsp;aktualisieren</strong>-Button, mit dem Sie das Schema-Update durchführen.
	</p>
	<p>Jetzt sollten Sie die Anwendung normal aufrufen und nutzen können.</p>
	<div class="alert alert-info">
		Falls Sie an dieser Stelle eine Fehlermeldung bekommen oder irgendetwas anderes nicht funktioniert, können Sie gerne
		unseren <a :href="context + '/kontakt/support'" target="_blank">Support</a> kontaktieren!
	</div>
	</div>
  </div>
</template>


<script>
import ProductTag from "./ProductTag.vue"
import Riskop15 from "./Riskop15.vue"
import TomcatPath from "./TomcatPath.vue"
import PgCmd from "./PgCmd.vue"

export default {
  props: {
	context: {
		type: String,
		required: true
	},
	imagepath: {
		type: String,
		required: true
	  }
  },
  data() {
    return {
		currentVersion: "1.5",
		numerus: "one",
		kritikomCoinstallation: "no",
    	osType: "windows",
      	javaVersion: "8",
      	tomcatVersion: "9",
      	dbType: "postgres",
      	productName: 'riskop',
	  	productVersion: '1.5.13',
	  	currentVersions: [
		  	{name: "riskop 1.2", value: "1.2-3"},
		  	{name: "riskop 1.3", value: "1.2-3"},
		  	{name: "riskop 1.4", value: "1.4"},
		  	{name: "riskop 1.5", value: "1.5"}
		  ],
		numeri: [
			{name: "riskop-Einzelinstallation", value: "one"},
			{name: "Multi-Instanz-Installation", value: "multi"}
		],
		kritikomCoinstallations: [
			{name: "ohne kritikom 1 im Tomcat", value: "no"},
			{name: "mit kritikom 1 im Tomcat", value: "yes"}
		],
      	osTypes: [
        	{name: "Windows Server", value: "windows"},
        	{name: "Linux", value: "linux"}
        ],
      	javaVersions: [
      		{name: "Java 7", value: "7"},
      		{name: "Java 8", value: "8"},
      		{name: "Java 9", value: "9"},
      		{name: "Java 10", value: "10"},
			{name: "Java 11", value: "11"},
			{name: "Java 12", value: "12"},
			{name: "Java 13", value: "13"},
			{name: "Java 14", value: "14"}
      	],
	    tomcatVersions: [
	      	{name: "Tomcat 7", value: "7"},
	      	{name: "Tomcat 8", value: "8"},
	      	{name: "Tomcat 9", value: "9"}
	      ],
	    dbTypes: [
	      	{name: "PostgreSQL", value: "postgres"},
	      	{name: "Microsoft SQL Server", value: "mssql"},
	      	{name: "MySQL", value: "mysql"}
	      ]
    };
  },
  computed: {
		dbName() {
			if (this.dbType == 'postgres') return "PostgreSQL"
			else if (this.dbType == 'mssql') return "Microsoft SQL-Server"
			else if (this.dbType == 'mysql') return "MySQL"
			else return "<keine Datenbank ausgewählt>";
		},
		javaName() {
			return "Java " + this.javaVersion;
		}
  },
  asyncComputed: {
  },
  methods: {
  },
  components: {
	  ProductTag,
	  Riskop15,
	  TomcatPath,
	  PgCmd
  }
};
</script>
